export const WINDOW_SECONDS = 10;

export function buildImportTimeline(recordings, importId) {
  const records = recordings
    .filter((record) => record.importId === importId)
    .slice()
    .sort(
      (a, b) =>
        (a.recordedAt || '').localeCompare(b.recordedAt || '') ||
        a.path.localeCompare(b.path, undefined, { numeric: true })
    );
  let total = 0;
  const leads = new Map();
  const segments = records.map((recording, index) => {
    const start = total;
    total += recording.duration;
    recording.leads.forEach((lead) =>
      leads.set(`${lead.id}:${lead.name}`, { key: `${lead.id}:${lead.name}`, name: lead.name })
    );
    const previous = records[index - 1];
    // Treat both wall-clock strings alike; do not infer a device timezone.
    const currentTime = recording.recordedAt
      ? Date.parse(`${recording.recordedAt.replace(' ', 'T')}Z`)
      : NaN;
    const previousTime = previous?.recordedAt
      ? Date.parse(`${previous.recordedAt.replace(' ', 'T')}Z`)
      : NaN;
    const gap =
      Number.isFinite(currentTime) && Number.isFinite(previousTime)
        ? (currentTime - previousTime) / 1000 - previous.duration
        : null;
    return { recording, start, end: total, gap };
  });
  return { segments, total, leads: Array.from(leads.values()) };
}

export function visibleSegments(timeline, start, duration = WINDOW_SECONDS) {
  return timeline.segments.filter(
    (segment) => segment.end > start && segment.start < start + duration
  );
}

export function clampPosition(position, total) {
  return Math.max(0, Math.min(Math.max(0, total - WINDOW_SECONDS), position));
}
